import default_styles from './styles';
import AssessTask from '../../../bz/assess-task';
class AssessContainerController
{
  constructor()
  {
    this.name = 'assessment-container';
    this.initComponents();
    this.initProps();
    this.initData();
    this.initComputed();
    this.initMethods();
    this.initHooks();
  }
  initComponents()
  {
  }
  initProps()
  {
  }
  initData()
  {
    this.data = ()=>{
      return {
        taskUrl: "",
        task: null,
        showAssessment: false,
        popoverAnchor: null,
      };
    };
  }
  initComputed()
  {
    this.computed = {
      applied_styles: {
        get()
        {
          return {...default_styles};
        }
      },
    };
  }
  initMethods()
  {
    this.methods = {
      onAssessMessage: this.onAssessMessage,
    }
  }
  initHooks()
  {
    this.mounted = this.onMounted;
    this.destroyed = this.onDestroyed;
  }
  onMounted()
  { 
    /**
     * TODO 步骤
     * # 创建新的测评任务并获得测评任务的uri
     * # 在iframe中展示渲染好的测评任务
     * # 接受iframe回传的测评完成的消息并回退至相应的页面
     */
    let template_uri = this.$route.query.template_uri;
    let case_id = this.$route.query.caseId;
    this.popoverAnchor = document.body;
    this.showAssessment = true;
    AssessTask.createTask(template_uri, case_id)
    .then((newTask=>
    {
      window.removeEventListener('message', this.onAssessMessage, false);
      window.addEventListener('message', this.onAssessMessage, false);
      this.task = newTask;
      this.taskUrl = newTask.taskUrl;
    }).bind(this));
  }
  onAssessMessage(ev)
  {
    let event = ev.data;
    if (event.type === "assess_task_done")
    {
      let task_uri = event.task_uri;
      this.task.finishAssessmentTask(task_uri)
      .then(resp=>resp.json())
      .then((resp=>{
        let caseId = this.$route.query.caseId;
        if ("" === caseId)
        {
          caseId = resp.caseId;
        }
        this.showAssessment = false;
        this.$router.push({ path: '/doc/cases/evalRecord/' + caseId});
      }).bind(this));
    }
    else if (event.type === 'request_cancel_assessment')
    {
      this.$router.go(-1);
    }
  }
  onDestroyed()
  {
    window.removeEventListener('message', this.onAssessMessage, false);
  }
};
export default AssessContainerController;



// WEBPACK FOOTER //
// ./src/components/bz/assess-container/controller.js